import { render, staticRenderFns } from "./WeekTemplateHeader.vue?vue&type=template&id=1f1f0bb5&scoped=true&"
import script from "./WeekTemplateHeader.vue?vue&type=script&lang=js&"
export * from "./WeekTemplateHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1f0bb5",
  null
  
)

export default component.exports